import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ff6c464"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Veuillez saisir vos identifiants", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cut-line" }, null, -1))
const _hoisted_3 = { id: "SideButton" }
const _hoisted_4 = {
  key: 0,
  class: "errormessage"
}
const _hoisted_5 = { class: "field-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Username" }, "Identifiant", -1))
const _hoisted_7 = { class: "field-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Password" }, "Mot de passe", -1))
const _hoisted_9 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_loader_dots = _resolveComponent("loader-dots")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "SignInView",
      class: _normalizeClass({ 'no-display': _ctx.showLoader })
    }, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1),
        _hoisted_1,
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoTo('/signup')))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.signup.use()
          }, null, 8, ["icon"]),
          _createTextVNode("S'inscrire")
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "gray",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GoTo('/recovery')))
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.forgotten.use()
          }, null, 8, ["icon"]),
          _createTextVNode("Mot de passe oublié")
        ])
      ]),
      _createElementVNode("form", null, [
        (_ctx.errorMsg != '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errorMsg), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.icons.username.use()
            }, null, 8, ["icon"])
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "Username",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.errorMsg = '')),
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.username) = $event)),
            class: _normalizeClass({ 'valid': _ctx.username != '' })
          }, null, 34), [
            [_vModelText, _ctx.username]
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _createVNode(_component_font_awesome_icon, {
              icon: _ctx.icons.password.use()
            }, null, 8, ["icon"])
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "Password",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.errorMsg = '')),
            type: "password",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
            class: _normalizeClass({ 'valid': _ctx.password != '' })
          }, null, 34), [
            [_vModelText, _ctx.password]
          ]),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.SignIn && _ctx.SignIn(...args)))
        }, "Accéder à mon espace client")
      ])
    ], 2),
    _createVNode(_component_loader_dots, {
      class: _normalizeClass(["loader-dots alone", { 'no-display': !_ctx.showLoader }])
    }, null, 8, ["class"])
  ], 64))
}